import angular from "angular";
import { PeriodType, Reports } from "@salaxy/core";
import { UiHelpers } from "../../services";

/**
 * Handles user interaction for displaying summary report
 */
export class SummaryReportDisplayController implements angular.IController {
  public static $inject = [
    "UiHelpers",
    "Reports"
  ];
  /**
   * Creates a new instance of SummaryReportDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(
    private uiHelpers: UiHelpers,
    private reports: Reports

  ) { }

  /**
   * Display Summary report
   * @param refDate date
   * @param type report type
   */
  public display(refDate: string, type: string): void {
    const data = {
      summaryReportData: null,
      isLoading: true
    };
    this.reports.getSummaryReportData(refDate, this.getPeriodType(type)).then(summaryReportData => {
      data.summaryReportData = summaryReportData;
      data.isLoading = false;
    });
    this.uiHelpers.showDialog(
      "salaxy-components/modals/report/SummaryReport.html",
      null,
      data,
      null,
      "landscape",
      true);
  }

  private getPeriodType(reportType: string): PeriodType {
    switch (reportType) {
      case "monthlyDetails":
        return PeriodType.Month;
      case "yearlyDetails":
        return PeriodType.Year;
    }
  }

}